import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon, Text, useTheme } from '@Sage/hoi-poi-ui';

const SelectionCountPill = memo(({ icon, countLabel, className }) => {
    const theme = useTheme();

    return (
        <span className={classNames('fm-select-recipients-modal__count-pill', className)}>
            <Icon
                name={icon}
                size="smallMedium"
                color={theme.colors.actionMinor[600]}
                className="fm-select-recipients-modal__count-pill-icon"
            />
            <Text
                type="caption"
                color={theme.colors.actionMinor[600]}
                className="fm-select-recipients-modal__count-pill-text"
            >
                {countLabel}
            </Text>
        </span>
    );
});

SelectionCountPill.displayName = 'SelectionCountPill';

SelectionCountPill.propTypes = {
    icon: PropTypes.string.isRequired,
    countLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default SelectionCountPill;
